import React from 'react';
import { Field, inputClass } from './BackgroundFields';
import { buildFontFamilySelectOptions } from '../utils/siteFonts';

export default function FontFamilySelectField({
  label = 'Police',
  value,
  onChange,
  siteTypography,
  includeSiteDefault = true,
}) {
  const options = buildFontFamilySelectOptions(siteTypography, { includeSiteDefault });

  return (
    <Field label={label}>
      <select className={inputClass} value={value || 'system'} onChange={(e) => onChange(e.target.value)}>
        {options.map((opt) => (
          <option key={opt.value} value={opt.value}>
            {opt.label}
          </option>
        ))}
      </select>
    </Field>
  );
}
